'use client';

import React from 'react';
import { resolveBopIcon } from '@/lib/icons/registry';
import {
  Calculator,
  Palette,
  FileText,
  Share2,
  HeartPulse,
  Code2,
  Receipt,
  BadgePercent,
  FileSpreadsheet,
  Pilcrow,
  Braces,
  Binary,
  Activity,
  Wrench,
  Zap,
  Car,
  Image as LucideImage,
  QrCode,
  Files,
  Scissors,
  Languages,
  GitCompare,
  Sparkles,
  AlignLeft,
  MessageSquare,
  Dices,
  Calendar,
  ShieldAlert,
  Clock,
  Link2,
  KeyRound,
  FileCode,
  Minimize2
} from 'lucide-react';

interface DynamicIconProps {
  name: string;
  className?: string;
}

export function DynamicIcon({ name, className = 'w-5 h-5' }: DynamicIconProps) {
  const bopIcon = resolveBopIcon(name);
  if (bopIcon) {
    return (
      <img
        src={bopIcon.assetPath}
        alt={bopIcon.label}
        className={`inline-block object-contain select-none pointer-events-none ${className}`}
        loading="lazy"
        draggable={false}
      />
    );
  }

  switch (name) {
    case 'Calculator':
      return <Calculator className={className} />;
    case 'Palette':
      return <Palette className={className} />;
    case 'FileText':
      return <FileText className={className} />;
    case 'Share2':
      return <Share2 className={className} />;
    case 'HeartPulse':
      return <HeartPulse className={className} />;
    case 'Code2':
      return <Code2 className={className} />;
    case 'Receipt':
      return <Receipt className={className} />;
    case 'BadgePercent':
      return <BadgePercent className={className} />;
    case 'FileSpreadsheet':
      return <FileSpreadsheet className={className} />;
    case 'Pilcrow':
      return <Pilcrow className={className} />;
    case 'Braces':
      return <Braces className={className} />;
    case 'Binary':
      return <Binary className={className} />;
    case 'Activity':
      return <Activity className={className} />;
    case 'Zap':
      return <Zap className={className} />;
    case 'Car':
      return <Car className={className} />;
    case 'Image':
      return <LucideImage className={className} />;
    case 'QrCode':
      return <QrCode className={className} />;
    case 'Files':
      return <Files className={className} />;
    case 'Scissors':
      return <Scissors className={className} />;
    case 'Languages':
      return <Languages className={className} />;
    case 'GitCompare':
      return <GitCompare className={className} />;
    case 'Sparkles':
      return <Sparkles className={className} />;
    case 'AlignLeft':
      return <AlignLeft className={className} />;
    case 'MessageSquare':
      return <MessageSquare className={className} />;
    case 'Dices':
      return <Dices className={className} />;
    case 'Calendar':
      return <Calendar className={className} />;
    case 'ShieldAlert':
      return <ShieldAlert className={className} />;
    case 'Clock':
      return <Clock className={className} />;
    case 'Link2':
      return <Link2 className={className} />;
    case 'KeyRound':
      return <KeyRound className={className} />;
    case 'FileCode':
      return <FileCode className={className} />;
    case 'Minimize2':
      return <Minimize2 className={className} />;
    default:
      return <Wrench className={className} />;
  }
}
